export default __webpack_public_path__ + "static/media/KN.7bf6f899.svg";